import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Contact } from './models/Contact'
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { HttpHeaders } from '@angular/common/http'
//import sgMail from '@sendgrid/mail';
// import sgMail = require('@sendgrid/mail');
//import * as sgMail from '@sendgrid/mail';
//import { SendgridService } from 'ngx-sendgrid';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private mailApi = 'https://mailthis.to/ajvbennett'
  
  // Sendgrid API key for ajvb@yahoo
  // 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

  // Password for MailJS
  // gicfej-sagwU2-qipxec

  // Pwd for website@jonraybuilding.co.uk = Boki810?

  private System: any; 

  constructor(private http: HttpClient
    //, private service: SendgridService
    ) { }

  PostMessage(input: any) {
    return this.http.post(this.mailApi, input, { responseType: 'text' })
      .pipe(
        map(
          (response) => {
            if (response) {
              return response;
            }
          },
          (error: any) => {
            return error;
          }
        )
      )
  }

  // SendMail() {
  // var payload = {
  //   "personalizations": [
  //     {
  //       "to": [
  //         {
  //           "email": "adrian_bennett@outlook.com"
  //         }
  //       ],
  //       "subject": "Hello World!"
  //     }
  //   ],
  //   "from": {
  //     "email": "ajvbennett@yahoo.co.uk"
  //   },
  //   "content": [
  //     {
  //       "type": "text/plain",
  //       "value": "Hello World!"
  //     }
  //   ]
  // };
  // var myHeaders = new Headers({
  //   "Content-Type": "application/json",
  //   "Authorization": "Bearer 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",
  // });
  // var data = new FormData();
  // data.append( "json", JSON.stringify( payload ) );
  // fetch("https://api.sendgrid.com/v3/mail/send",
  // {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: data
  // })
  // .then(function(res){ return res.json(); })
  // .then(function(data){ console.log( JSON.stringify( data ) ) })
  // }

  // SendGrid() {

  //   const msg = {
  //     to: 'adrian_bennett@outlook.com',
  //     from: 'ajvbennett@outlookyahoo.co.uk', // Use the email address or domain you verified above
  //     subject: 'Sending with Twilio SendGrid is Fun',
  //     text: 'and easy to do anywhere, even with Angular',
  //     html: '<strong>and easy to do anywhere, even with Angular</strong>',
  //   };

  // }
}